<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="result-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>

                    <div class="box-view">
                        <div class="box-wrapper flex-between-start flex-wrap">
                            <div class="box-item" v-for="(item,index) in basket" :key="index">
                                <div class="goods-detail">
                                    <div class="goods-wrapper">
                                        <div class="goods-pic" v-tips="item.giftId"><game-item :locked="true" :id="item.giftId" :num="item.sendNum"></game-item></div>
                                    </div>                                 
                                </div>                
                            </div>
                            <div class="box-item box-temp" v-for="n in 6 - basket.length" :key="'box-' + n"></div>
                        </div>
                    </div>

                    <div class="notice">                        
                        每个用户仅可兑换一次，建议选择高品质道具兑换，请仔细确认！
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()"></div>  
                        <div class="u-btn ok" @click="pack_apply()"></div>                                                                 
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.result-modal{
    position: relative;
    // width: 628px;
    // height: 568px;
    // background-image: url(~@/assets/images/modal/bg-modal-comfirm.png);     
}

.title{
    width: 516px;
    height: 51px;
    margin: 0 auto 35px;
    background-image: url(~@/assets/images/modal/title-comfirm.png);
}

.box-view{

    .box-wrapper{
        padding: 0 60px 0;
    }

    .box-item{
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 106px;
        height: 105px;
        margin: 0 16px 24px;
        background-image: url(~@/assets/images/bg-item_2.png);
    }

}

.item-pic{
    width: 46px;
    height: 46px;
}

.notice{
    text-align: center;
    color: #a09390;
    font-size: 20px;
    padding: 0 60px;
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin-top: 30px;
}

.u-btn.ok{
    width: 266px;
    height: 69px;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 266px;
    height: 69px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

</style>

<script>
import { apiPackApply, } from '@/api/index';
export default {
    data () {
        return {
            visible : false,
            text : '',
            isSSr : false,
            item : {},
            basket : [],
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
        if(this.item.gameGiftId == 'NL78' && this.item.sendNum == 100000)this.isSSr = true;
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy();
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        pack_apply(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            if(this.basket.length != 6){
                return this.$toast('请先选择6个游戏道具');
            }

            let pack_data =[];

            this.basket.forEach(function(val) {
                pack_data.push({ id : val.id , groupId : val.groupId })
            }, {});            

            apiPackApply(pack_data).then(
                res => {
                    //this.$toast('领取成功');
                    this.destroyElement();
                    this.$msg_modal({type : 'success' ,});
                    this.$update_evt();
                    this.$store.commit('$_setFlag', 1);
                },
                rej => {
                    let msg = rej.code == 1202 ? '结义值不足，完成任务领更多' : rej.message;
                    this.$toast(msg);
                },
            )
        },               
    },    
}
</script>